<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/settings']">Übersicht</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/conditions/overview']">Zahlungs- und Lieferbedingungen</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [routerLink]="['/material/overview']">Material</a>
    </li>
    <li class="nav-item" *ngIf="isAdmin">
      <a class="nav-link" [routerLink]="['/staff/overview']">Mitarbeiter</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Konfiguration</h2>

  <div class="clr-row">
    <div class="clr-col-lg-4 clr-col-12">
      <div class="card">
        <div class="card-header">MinIO</div>
        <div class="card-block">
          <div class="card-title">Der moderne AWS‑S3‑konforme Datenspeicher</div>
          <div class="card-text">
            MinIO stellt den internen Objektspeicher bereit und versorgt RMS mit Dateien, Dokumenten und Uploads.
          </div>
        </div>
        <ul class="list-group">
          <li class="list-group-item">Status: {{ minioStatusText }}</li>
          <li class="list-group-item">Ready: {{ minioReadyText }}</li>
          <li class="list-group-item">Live: {{ minioLiveText }}</li>
          <li class="list-group-item">Endpoint: {{ minioEndpoint }}</li>
          <li class="list-group-item">Bucket: {{ minioBucket }}</li>
          <li class="list-group-item">Bucket vorhanden: {{ minioBucketExistsText }}</li>
          <li class="list-group-item">Versioning: {{ minioBucketVersioning }}</li>
          <li class="list-group-item">Policy: {{ minioBucketPolicy }}</li>
          <li class="list-group-item">Region: {{ minioRegion }}</li>
          <li class="list-group-item">AccessKey: {{ minioAccessKey }}</li>
          <li class="list-group-item" *ngIf="minioError">Fehler: {{ minioError }}</li>
        </ul>
        <div class="card-footer">
          <button class="btn btn-sm btn-link" (click)="reload()" [disabled]="loading">Aktualisieren</button>
          <span class="stand" *ngIf="lastUpdated">Stand: {{ lastUpdated | date:'HH:mm:ss' }}</span>
        </div>
      </div>
    </div>
    <div class="clr-col-lg-4 clr-col-12">
      <div class="card">
        <div class="card-header">MySQL</div>
        <div class="card-block">
          <div class="card-title">Der robuste SQL‑Kern für Stammdaten</div>
          <div class="card-text">
            MySQL ist die zentrale Datenbank für Projekte, Komponenten, Material und alle transaktionalen Daten.
          </div>
        </div>
        <ul class="list-group">
          <li class="list-group-item">Status: {{ dbStatusText }}</li>
          <li class="list-group-item">DB: {{ dbName }}</li>
          <li class="list-group-item">Host: {{ dbHost }}</li>
          <li class="list-group-item">Version: {{ dbVersion }}</li>
          <li class="list-group-item">Uptime: {{ dbUptime }}</li>
          <li class="list-group-item">Größe: {{ dbSize }}</li>
          <li class="list-group-item">Connections: {{ dbThreadsConnected }} / {{ dbMaxConnections }}</li>
          <li class="list-group-item" *ngIf="dbError">Fehler: {{ dbError }}</li>
        </ul>
        <div class="card-footer">
          <button class="btn btn-sm btn-link" (click)="reload()" [disabled]="loading">Aktualisieren</button>
          <span class="stand" *ngIf="lastUpdated">Stand: {{ lastUpdated | date:'HH:mm:ss' }}</span>
        </div>
      </div>
    </div>
    <div class="clr-col-lg-4 clr-col-12">
      <div class="card">
        <div class="card-header">OpenTelemetry</div>
        <div class="card-block">
          <div class="card-title">Tracing & Observability für RMS</div>
          <div class="card-text">
            OpenTelemetry sammelt Traces und hilft bei der Analyse von Performance und Fehlern im Backend.
          </div>
        </div>
        <ul class="list-group">
          <li class="list-group-item">Status: {{ tracingEnabledText }}</li>
          <li class="list-group-item">OTLP: {{ tracingEndpoint }}</li>
          <li class="list-group-item">Service: {{ tracingServiceName }}</li>
        </ul>
        <div class="card-footer">
          <button class="btn btn-sm btn-link" (click)="reload()" [disabled]="loading">Aktualisieren</button>
          <span class="stand" *ngIf="lastUpdated">Stand: {{ lastUpdated | date:'HH:mm:ss' }}</span>
        </div>
      </div>
    </div>
  </div>
</main>
